<template>
  <div>
    <div class="fullpage landing_color_bg">
      <div class="container">
        <div class="col-md-7 col-sm-7">
          <h1>DISCOVER THE HARD HITTING AND PROFIT YIELDING STOCKS.</h1>
          <p class="headline">Non-conventional, Market-beating & wealth building stocks to maximize your profits thorough research and knowledge based real market facts.</p>
          <p class="headline"> Enhance your investing acumen and learn which businesses are going to be tomorrow’s stock market leaders, and see which companies are the best stocks to invest in today</p>
        </div>
        <div class="col-md-5 col-sm-5">
          <img
            src=""
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="landing_color_band">
      <div class="container">
        <div class="col-md-10 col-sm-10 col-sm-offset-1 col-md-offset-1">
          <p class="headline">
            <i>
              “Long term buy and hold investing might not look exciting to day traders. But it can generate exciting long term returns and beat out intra-day traders.” </i>
          </p>
        </div>
      </div>
    </div>
    <!-- <div
      class="container"
      id="landing_graph_section"
    >
      <div class="row">
        <h4>Stock advice that beats the market</h4>
        <p class="mb-4">GROW WITH STOCKS is helping everyday retail investors like you to beat the market, make money and save time.</p>
        <div class="col-md-6 col-sm-10 col-sm-offset-1 col-md-offset-3">
          <CummilativeGraph></CummilativeGraph>
        </div>
      </div>
      <div class="row mt-4">
        <h4>A few of our wealth-creating stock picks.</h4>
         <p>Lorem ipssum Lorem ipssumLorem ipssumLorem ipssumLorem ipssumLorem ipssumLorem ipssumLorem <br />ipssumLorem ipssum Lorem ipssumLorem ipssum Lorem ipssum</p> 
        <div class="col-md-10 col-sm-10 col-sm-offset-1 col-md-offset-1">
          <div
            class="col-md-3 col-sm-6"
            v-for="stock in stockData"
            :key="stock.name"
          >
            <div class="stock_card elevation-3">
              <p> {{ stock.name }} <span class="pull-right"><i class="fas fa-arrow-up" aria-hidden="true"></i> {{ getPercentageChange(stock.data)}} % </span></p>
            </div>
          </div>
          <p class="mt-4">Imagine investing in the stocks like above before they became popular to grab the maximum returns.</p>
        </div>
      </div>
    </div> -->
    <!-- <div class="row mt-4 landing_color_band">
      <div class="container">
        <div class="col-md-8 col-md-offset-2">
          <h4 class="headline"> <i> Imagine investing in the stocks like above before they became popular to grab the maximum returns. </i></h4>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="row fullpage">
        <div class="col-md-12">
          <h2 class="display-1" id="pricing_section">
            <span class="heading_bdr_btm">Pricing</span>
          </h2>
          <!-- Mobile Pricing Page Starts -->
          <div class="row mb-4 visible-xs mt-4" role="group" aria-label="Choose a pricing plan to compare">
            <button
              type="button"
              :aria-pressed="currentPricing === '12 Months'"
              aria-controls="mobile-pricing-table"
              @click="currentPricing = '12 Months'"
              class="col-xs-4 pricing_tab"
              :class="{'active_pricing_tab elevation-4' : currentPricing === '12 Months'}"
            >
              <span>Starter</span>
            </button>
            <button
              type="button"
              :aria-pressed="currentPricing === '24 Months'"
              aria-controls="mobile-pricing-table"
              @click="currentPricing = '24 Months'"
              class="col-xs-4 pricing_tab"
              :class="{'active_pricing_tab elevation-4' : currentPricing === '24 Months'}"
            >
              <span>Growth</span>
            </button>
            <button
              type="button"
              :aria-pressed="currentPricing === '36 Months'"
              aria-controls="mobile-pricing-table"
              @click="currentPricing = '36 Months'"
              class="col-xs-4 pricing_tab"
              :class="{'active_pricing_tab elevation-4' : currentPricing === '36 Months'}"
            >
              <span>Wealth Creator</span>
            </button>
          </div>
          <table id="mobile-pricing-table" class="table visible-xs" aria-live="polite">
            <caption class="sr-only">Pricing details for the selected plan ({{ currentPricing }})</caption>
            <tbody>
              <!-- <tr>
                <td colspan="2 mobile_table_heading">
                  GROW WITH STOCKS <br><span>Invest Smartly</span>
                </td>
              </tr> -->
              <!-- <tr>
                <td>Overview</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                > <b> ₹35,000 </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="limited_time_green">Limited time offer</span></td>
              </tr> -->

              <tr>
                <td>Total Price</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                > <b> ₹45,000 </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><b> ₹80,000</b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >
                 <b> ₹1,50,000</b>
                </td>
              </tr>

              <tr>
                <td>Plan Duration</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                > <b> 1 Year </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><b> 2 Years </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >
                 <b> 3 Years</b>
                </td>
              </tr>

               <tr>
                <td>Payment Terms</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                > <b>Single installment (₹45,000) </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><b> Two installments (₹40,000/year) </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                > <b> Three installments (₹50,000/year)</b></td>
              </tr>

               <tr>
                <td>Refund Policy</td>
                <td
                  class="td-custom"
                > <b> Cancel anytime – refund for unused months <br> (excluding taxes) </b></td>
               
              </tr>

              <tr>
                <td>Total Stocks Recommendations</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                > <b> 10 </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><b> 20 </b></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >36</td>
              </tr>

               <tr>
                <td>Flagship Multibagger Stocks</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> 6 Picks (2 per year)</td>
              </tr>

               <tr>
                <td>Detailed Research Reports</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              </tr>

               <tr>
                <td>Buy & Sell Instructions</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              </tr>

               <tr>
                <td>Regular Stock Updates</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              </tr>

               <tr>
                <td>Capital Allocation Strategy</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              </tr>
                              
              <tr>
                <td>Personalised Strategy Calls</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                >2 Calls</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                >4 Calls</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >Unlimited (as needed)</td>
              </tr>


               <tr>
                <td>Past Portfolio Guidance</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> </td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> </td>
              </tr>

               <tr>
                <td>Support</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >Priority Support</td>
              </tr>

               <tr>
                <td>Beginner’s Kit & Articles</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                ><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              </tr>


              <tr>
                <td>Once Subscribed <br> What You get</td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '12 Months'"
                >  <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Research Report <br> with Each Idea 
                </td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '24 Months'"
                >  <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Research Report with Each Idea
                </td>
                <td
                  class="td-custom"
                  v-if="currentPricing === '36 Months'"
                >  <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Research Report with Each Idea <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-1"></i>Two Flagship Stocks Per Year</td>
              </tr>

              <!-- <tr
                v-for="data in pricingData"
                :key="data.text"
                v-if="data.text !== 'Subscription Period'"
              >
                <td>{{ data.text }}</td>
                <td>
                  <span v-if="data[currentPricing]"><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check pull-right"></i></span>
                  <span v-else><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false pull-right"></i></span>
                </td>
              </tr> -->
            </tbody>
          </table>
          <button
            v-if="currentPricing === '12 Months'"
            type="button"
            class="btn btn--block btn--full btn_custom visible-xs"
            aria-label="Subscribe to Starter plan"
            @click="orderNow(12)"
          >Subscribe</button>
          <button
            v-if="currentPricing === '24 Months'"
            type="button"
            class="btn btn--bloc btn--full btn_custom visible-xs"
            aria-label="Subscribe to Growth plan"
            @click="orderNow(24)"
          >Subscribe</button>
          <button
            v-if="currentPricing === '36 Months'"
            type="button"
            class="btn btn--block btn--full btn_custom visible-xs"
            aria-label="Subscribe to Wealth Creator plan"
            @click="orderNow(36)"
          >Subscribe</button>


          <!-- Mobile Pricing Page Ends -->
          <table class="table mt-5 table--striped hidden-xs">
            <caption class="sr-only">Comparison of Starter, Growth and Wealth Creator subscription plans</caption>
            <thead>
              <tr class="table_heading">
                <th scope="col" class="pl-3">Plan</th>
                <th scope="col" class="td-custom">Starter</th>
                <th scope="col" class="td-custom black">Growth</th>
                <th scope="col" class="td-custom">Wealth Creator</th>
              </tr>
            </thead>
            <tbody>
            <tr class="">
              <td class="pa-3 subheading">Total Price</td>
              <td class="td-custom headline"><b> ₹ 45,000 </b></td>
              <td class="td-custom headline"><b> ₹ 80,000 </b></td>
              <td class="td-custom headline">
                 <!-- <span class="strike-through">₹1,40,000</span> -->
                  <b> ₹1,50,000 </b></td>
            </tr>

            <tr class="">
              <td class="pa-3 subheading">Plan Duration</td>
              <td class="td-custom subheading"><b> 1 Year </b></td>
              <td class="td-custom subheading"><b> 2 Years </b></td>
              <td class="td-custom subheading">
                  <b> 3 Years </b></td>
            </tr>

            <tr>
              <td class="pa-3 subheading">
              Payment Terms
              </td>
              <td
                class="td-custom subheading"
              > <b> Single Installment (₹45,000) </b></td>
              <td
                class="td-custom subheading"
              ><b> Two installments (₹40,000/year) </b></td>
              <td
                class="td-custom subheading"
              ><b> Three installments (₹50,000/year) </b></td>
            </tr>

             <tr>
              <td class="pa-3 subheading">Refund Policy</td>
              <td class="td-custom"> <b> Cancel anytime – refund for unused months (excluding taxes) </b></td>
              <td class="td-custom"> <b> Cancel anytime – refund for unused months (excluding taxes) </b></td>
              <td class="td-custom"> <b> Cancel anytime – refund for unused months (excluding taxes) </b></td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Total Stock Recommendations</td>
              <td class="td-custom"> 10 </td>
              <td class="td-custom"> 20 </td>
              <td class="td-custom"> 36 </td>
            </tr>
            
            <tr>
              <td class="pa-3 subheading">Flagship Multibagger Stocks</td>
              <td class="td-custom"> <span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i> </td>
              <td class="td-custom"> <span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i> </td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> 6 Picks (2 per year)</td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Detailed Research Reports</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Buy & Sell Instructions</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Regular Stock Updates</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Capital Allocation Strategy</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
            </tr>
            
            <tr>
              <td class="pa-3 subheading">Personalised Strategy Calls</td>
              <td class="td-custom"> 2 Calls</td>
              <td class="td-custom"> 4 Calls</td>
              <td class="td-custom"> Unlimited (as needed)</td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Past Portfolio Guidance</td>
              <td class="td-custom"> <span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i> </td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> </td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i> </td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Support</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> Priority Support</td>
            </tr>

            <tr>
              <td class="pa-3 subheading">Beginner’s Kit & Articles</td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
              <td class="td-custom"> <span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></td>
            </tr>

            <tr>
              <td class="pa-5 subheading">Once Subscribed <br> What You get</td>
               <td class="td-custom">
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Research Report with Each Idea <br>
                 <i aria-hidden="true" class="fas true mr-2 mb-3"></i>
              </td>
                <td class="td-custom">
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Research Report with Each Idea<br>
                 <i aria-hidden="true" class="fas true mr-2 mb-3"></i>
              </td>
              <td class="td-custom">
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Monthly Stock Ideas <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Research Report with Each Idea <br>
                 <i aria-hidden="true" class="fas true fa-check mr-2 mb-3"></i>Two Flagship Stocks Per Year
              </td>
            </tr>



            <!-- <tr
              v-for="data in pricingData"
              :key="data.text"
            >
              <td class="pa-3 subheading">{{ data.text }} </td>
              <td class="td-custom">
                <span v-if="data['24 Months']"><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></span>
                <span v-else><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i></span>
              </td>
              <td class="td-custom">
                <span v-if="data['36 Months']"><span class="sr-only">Included</span><i aria-hidden="true" class="fas true fa-check"></i></span>
                <span v-else><span class="sr-only">Not included</span><i aria-hidden="true" class="fas fa-times false"></i></span>
              </td>
            </tr> -->
            <tr class="last_tr">
              <td></td>
                <td>
                <button
                  type="button"
                  class="btn btn--block btn_custom subscribe-cell-btn"
                  aria-label="Subscribe to Starter plan"
                  @click="orderNow(12)"
                >Subscribe</button>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn--block btn_custom subscribe-cell-btn"
                  aria-label="Subscribe to Growth plan"
                  @click="orderNow(24)"
                >Subscribe</button>
              </td>
              <td><button
                  type="button"
                  class="btn btn--block btn_custom subscribe-cell-btn"
                  aria-label="Subscribe to Wealth Creator plan"
                  @click="orderNow(36)"
                >Subscribe</button></td>
            </tr>
            </tbody>
          </table>
          <p class="mt-4 text-muted" style="font-size: 13px;">
            *service period lasts until all promised stock recommendations under the plan are delivered, subject to market conditions, If market conditions are not favorable, the delivery timeline may extend beyond the stated plan duration at no extra cost.
          </p>
        </div>
      </div>
    </div>
    <section class="fullpage" aria-labelledby="testimonials-heading">
      <div class="container custom_container">
        <h2 class="display-1" id="testimonials-heading">
          <span class="heading_bdr_btm">Testimonials</span>
        </h2>
        <div class="text-center mb-3">
          <button
            type="button"
            class="btn carousel-pause-btn"
            @click="autoplay = !autoplay"
            :aria-pressed="autoplay ? 'true' : 'false'"
            :aria-label="autoplay
              ? 'Pause testimonials carousel auto-rotation, currently playing'
              : 'Play testimonials carousel auto-rotation, currently paused'"
          >
            <span aria-hidden="true">{{ autoplay ? '⏸' : '▶' }}</span>
            <span aria-hidden="true">{{ autoplay ? 'Pause testimonials' : 'Play testimonials' }}</span>
            <span class="sr-only">(currently {{ autoplay ? 'playing' : 'paused' }})</span>
          </button>
        </div>
        <div class="testimonials mt-3" role="region" aria-roledescription="carousel" aria-label="Customer testimonials">
          <p class="sr-only" aria-live="polite" aria-atomic="true">{{ carouselAnnouncement }}</p>
          <v-carousel
            ref="testimonialCarousel"
            v-model="carouselIndex"
            :cycle="autoplay"
            hide-delimiters
            :light="true"
            :height="500"
            prev-icon="keyboard_arrow_left"
            next-icon="keyboard_arrow_right"
          >
            <v-carousel-item aria-roledescription="slide" aria-label="Slide 1 of 3">
              <div class="col-md-12 testimonials_card">
                <v-card class="pa-2 elevation-2">
                  <p>
                    My name is Jay Shah. I Joined GWS services 4 years ago and here is my honest review on it.
                    I would like to say that I am in stock market because of “GWS&quot;. My total investment in last 4 years is
                    7 Lacs and I have returns of 21+ Lacs because of <strong>GWS.</strong> There is no other way, that could have made
                    this kind of return, so I am very thankful to <strong>GWS</strong> family.
                    <br>
                    I would like to mention that within 2
                    years many stocks in my portfolio made huge returns like 3 to 6 times. I am very happy with GWS.
                    Thank You. </p>
                  <img
                    src="../assets/gws_jay.jpg"
                    class="img-circle testimonial_img"
                    alt="Photo of Jai Shah, Grow With Stocks client"
                  >
                  <h3 class="testimonial-name"> Jai Shah </h3>
                </v-card>
              </div>
            </v-carousel-item>
            <v-carousel-item aria-roledescription="slide" aria-label="Slide 2 of 3">
              <div class="col-md-12 testimonials_card">
                <v-card class="pa-2 elevation-2">
                  <p>
                    I am Gayathri Umachandran from Cuddalore. I had started trading a few years back, but mostly did it
                    from random suggestions I got from news channels and through some irregular study. Only in the
                    year 2014, I had made my association with <strong>GROW WITH STOCKS</strong> and took an annual subscription. I
                    have not repented ever since. They have not only made me richer monetarily but also
                    knowledgeable.
                    The fact that I recommend it to my friends and even mentioned it in my Facebook status, shows my
                    respect for the <strong>GROW WITH STOCKS</strong> team.</p>

                  <img
                    src="../assets/gws_gayathri.jpg"
                    class="img-circle testimonial_img"
                    alt="Photo of Gayathri Umachandran, Grow With Stocks client"
                  >
                  <h3 class="testimonial-name"> Gayathri Umachandran </h3>
                </v-card>
              </div>
            </v-carousel-item>
            <v-carousel-item aria-roledescription="slide" aria-label="Slide 3 of 3">
              <div class="col-md-12 testimonials_card">
                <v-card class="pa-2 elevation-2">
                  <p>
                    <br>
                    Grow With Stocks find hidden gems at very attractive price. Their recommendations are based on
                    plain business fundamentals and they do not encourage trading. They believe in Investment
                    philosophy with a horizon of at least 1-2 years. I recommend <strong>GWS</strong> to everyone who would like to
                    become a better investor and make money in the stock market. </p>
                  <br>
                  <br>
                  <img
                    src="../assets/gws_hardik.jpg"
                    class="img-circle testimonial_img"
                    alt="Photo of Hardik Patwa from Mumbai, Grow With Stocks client"
                  >
                  <h3 class="testimonial-name"> Hardik Patwa, Mumbai </h3>
                </v-card>
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
      </div>
    </section>
    <section class="faq_section" aria-labelledby="pricing-faq-heading">
      <div class="container">
        <h2 class="display-1" id="pricing-faq-heading">
          <span class="heading_bdr_btm">FAQ's</span>
        </h2>
        <faq-child></faq-child>
      </div>
    </section>
    <!-- Thank you dialog -->

    <v-dialog
      v-model="openThankyouPopup"
      max-width="500"
      persistent
    >
      <v-card class="pa-4">
        <v-card-title class="headline"> Thanks for joining <br> GROW WITH STOCKS. </v-card-title>
        <v-card-text>
          Your subscription is successful and you have taken the first step towards great success in your investing journey.
        </v-card-text>
        <v-divider></v-divider>
        <router-link
          to="/myaccount"
          class="btn btn_custom"
        >Visit My Account</router-link>
      </v-card>
    </v-dialog>
    <!-- Thank you dialog -->
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import stockData from "../util/stock-pricing.json";
  import PricingData from "../util/pricing.json";
  import FaqChild from "../components/FaqChild";
  import lb from "../util/lb";
  import CummilativeGraph from "../components/CummilativeGraph.vue";

  export default {
    name: "Pricing",
    components: {
      FaqChild,
      CummilativeGraph
    },
    mounted() {
      this.currentPricing = "24 Months";
      lb.get("/api/Stocks/getplanslist").then(({ data }) => (this.plans = data));
      // WCAG 2.3.3 — honor reduced-motion preference for auto-cycling carousel
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.autoplay = false;
      }
      this.$nextTick(() => this.relabelCarouselButtons());
    },
    data() {
      return {
        pricingData: PricingData["pricing Table"],
        currentPricing: "24 Months",
        plans: [],
        openThankyouPopup: false,
        autoplay: true,
        carouselIndex: 0,
        carouselAnnouncement: '',
        testimonialNames: ['Jai Shah', 'Gayathri Umachandran', 'Hardik Patwa, Mumbai']
      };
    },
    watch: {
      carouselIndex(newIdx) {
        const name = this.testimonialNames[newIdx] || `${newIdx + 1}`;
        this.carouselAnnouncement = `Showing testimonial ${newIdx + 1} of ${this.testimonialNames.length}: ${name}`;
      }
    },
    computed: {
      ...mapGetters(["user"]),
      stockData() {
        return stockData;
      }
    },
    methods: {
      orderNow(month) {
        if (!this.user) {
          this.$router.push("/signup?source=pricing");
          return;
        }
        const selectedPlan = this.plans.find(item => item.months === month);
        if (!selectedPlan) {
          this.$toasted.error("Some Error Occured !! ", {
            position: "bottom-right",
            duration: 2000
          });
          return;
        }
        var options = {
          key: "rzp_live_TXZcFAfGz1uA2v",
          amount: selectedPlan.price * 100, // Accepts in paise
          name: "GROW WITH STOCKS",
          description: `${selectedPlan.name} Subscription`,
          // image: "../assets/gws logo.png",
          handler: response => {
            lb.post("/api/Orders", {
              amount: selectedPlan.price,
              razorpay_id: response.razorpay_payment_id,
              plan: selectedPlan.name,
              gWSUserId: this.user.id
            })
              .then(() => {
                return lb.post("/api/Subscriptions/replaceOrCreate", {
                  type: selectedPlan.id,
                  date: new Date(),
                  gWSUserId: this.user.id
                });
              })
              .then(() => {
                // open thank you popup
                this.openThankyouPopup = true;
              });
          },
          prefill: {
            name: this.user.first_name,
            email: this.user.email,
            contact: this.user.phone
          },
          theme: {
            color: "#23906d"
          }
        };
        var rzp1 = new Razorpay(options);
        rzp1.open();
        // e.preventDefault();
      },
      relabelCarouselButtons() {
        const root = this.$refs.testimonialCarousel && this.$refs.testimonialCarousel.$el;
        if (!root) return;
        const prev = root.querySelector('.v-carousel__prev .v-btn, .v-carousel__controls__item');
        const next = root.querySelector('.v-carousel__next .v-btn');
        // Vuetify 1.x renders prev/next as direct children buttons
        const buttons = root.querySelectorAll('button');
        buttons.forEach(btn => {
          const icon = btn.querySelector('.v-icon, i');
          if (!icon) return;
          const cls = icon.className || '';
          if (cls.indexOf('keyboard_arrow_left') !== -1 || icon.textContent.indexOf('keyboard_arrow_left') !== -1) {
            btn.setAttribute('aria-label', 'Previous testimonial');
            btn.classList.add('carousel-nav-btn');
          } else if (cls.indexOf('keyboard_arrow_right') !== -1 || icon.textContent.indexOf('keyboard_arrow_right') !== -1) {
            btn.setAttribute('aria-label', 'Next testimonial');
            btn.classList.add('carousel-nav-btn');
          }
        });
      },
      getPercentageChange(data) {
        const last = data[data.length - 1].High;
        const first = data[0].High;
        return Math.round(((last - first) / first) * 100);
      }
    }
  };
</script>

<style lang="scss" scoped>
  // .heading_bdr_btm {
  //   padding-bottom: 5px;
  //   border-bottom: 3px #31cc9a solid;
  // }
  .fullpage {
    padding-top: 10vh;
    min-height: 80vh;
  }
  #landing_graph_section {
    h4 {
      font-size: 30px;
      font-weight: 600;
      line-height: 36px;
      text-align: center;
      margin: 30px 0;
    }
    p {
      text-align: center;
      font-weight: 300;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 60px;
    }
    .stock_card {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      p {
        text-align: left;
        font-weight: 800;
        font-size: 14px;
        padding: 17px;
        margin-bottom: 0;
        span {
          color: #1a7055;
          font-weight: 800;
        }
      }
    }
    .stock_card:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10);
    }
  }

  .landing_color_band {
    background-color: #f7f7f7;
    text-align: center;
  }
  .sr-only {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .carousel-pause-btn {
    background-color: #1a7055;
    color: #fff;
    border: 2px solid transparent;
    padding: 8px 18px;
    border-radius: 4px;
    font-weight: 600;
  }
  .carousel-pause-btn:hover,
  .carousel-pause-btn:focus {
    background-color: #0d3d2e;
    color: #fff;
  }
  .carousel-pause-btn:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
  }
  .subscribe-cell-btn {
    width: 80%;
    margin: auto;
    display: block;
    max-width: 240px;
  }
  /* WCAG 1.4.11 — carousel prev/next icons must meet 3:1 against background */
  /* WCAG 2.5.5/2.5.8 — touch target ≥ 44×44 */
  /* ::v-deep needed because v-carousel renders the buttons in a child component */
  ::v-deep .carousel-nav-btn {
    background-color: #0d3d2e !important;
    color: #fff !important;
    margin: 0 6px;
    min-width: 44px !important;
    min-height: 44px !important;
    width: 44px !important;
    height: 44px !important;
    opacity: 1 !important;
  }
  ::v-deep .carousel-nav-btn:hover,
  ::v-deep .carousel-nav-btn:focus {
    background-color: #000000 !important;
    color: #fff !important;
  }
  ::v-deep .carousel-nav-btn:focus,
  ::v-deep .carousel-nav-btn:focus-visible {
    outline: 3px solid #0d3d2e !important;
    outline-offset: 3px !important;
    box-shadow: 0 0 0 6px #fff, 0 0 0 9px #0d3d2e !important;
  }
  ::v-deep .carousel-nav-btn:before,
  ::v-deep .carousel-nav-btn:hover:before,
  ::v-deep .carousel-nav-btn:focus:before,
  ::v-deep .carousel-nav-btn--active:before {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  ::v-deep .carousel-nav-btn .v-icon,
  ::v-deep .carousel-nav-btn i {
    color: #fff !important;
    font-size: 24px !important;
  }
  /* Direct Vuetify selectors — applies even if JS relabel hasn't run yet */
  ::v-deep .v-carousel .v-carousel__controls,
  ::v-deep .v-carousel__prev,
  ::v-deep .v-carousel__next {
    z-index: 2;
  }
  ::v-deep .v-carousel__prev .v-btn,
  ::v-deep .v-carousel__next .v-btn,
  ::v-deep .v-carousel__prev button,
  ::v-deep .v-carousel__next button {
    background-color: #0d3d2e !important;
    color: #fff !important;
    min-width: 44px !important;
    min-height: 44px !important;
    width: 44px !important;
    height: 44px !important;
    opacity: 1 !important;
    border-radius: 50% !important;
  }
  /* Vuetify renders a .v-btn:before overlay that becomes currentColor on hover/focus.
     With our white icon color, that overlay paints WHITE over the dark green button,
     which is exactly the "grayish" wash you see. Neutralize it. */
  ::v-deep .v-carousel__prev .v-btn:before,
  ::v-deep .v-carousel__next .v-btn:before,
  ::v-deep .v-carousel__prev .v-btn:hover:before,
  ::v-deep .v-carousel__next .v-btn:hover:before,
  ::v-deep .v-carousel__prev .v-btn:focus:before,
  ::v-deep .v-carousel__next .v-btn:focus:before,
  ::v-deep .v-carousel__prev .v-btn--active:before,
  ::v-deep .v-carousel__next .v-btn--active:before {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  ::v-deep .v-carousel__prev .v-btn:hover,
  ::v-deep .v-carousel__next .v-btn:hover {
    background-color: #000000 !important;
    color: #fff !important;
  }
  ::v-deep .v-carousel__prev .v-btn:focus,
  ::v-deep .v-carousel__next .v-btn:focus,
  ::v-deep .v-carousel__prev .v-btn:focus-visible,
  ::v-deep .v-carousel__next .v-btn:focus-visible {
    background-color: #000000 !important;
    color: #fff !important;
    outline: 3px solid #0d3d2e !important;
    outline-offset: 3px !important;
    box-shadow: 0 0 0 6px #fff, 0 0 0 9px #0d3d2e !important;
  }
  ::v-deep .v-carousel__prev .v-icon,
  ::v-deep .v-carousel__next .v-icon,
  ::v-deep .v-carousel__prev i,
  ::v-deep .v-carousel__next i {
    color: #fff !important;
  }
  .pricing_tab {
    background: #f1f1f1;
    border: 2px solid #d4d4d4;
    border-radius: 6px;
    padding: 14px 6px;
    font-weight: 600;
    color: #2d2d2d;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
  }
  .pricing_tab:hover {
    background: #e5ebe8;
    border-color: #b8c4be;
    transform: translateY(-1px);
  }
  .pricing_tab[aria-selected="true"] {
    background: #1a7055;
    color: #fff;
    border-color: #0d3d2e;
    box-shadow: 0 4px 12px rgba(26, 112, 85, 0.25);
  }
  .pricing_tab[aria-selected="true"]:hover {
    background: #0d3d2e;
    transform: translateY(-1px);
  }
  .pricing_tab:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
  }
  .landing_color_bg {
    h1 {
      font-size: 60px;
      font-weight: 800;
      color: #fff;
      letter-spacing: -1px;
      line-height: 1.1;
      text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
    }
    h4 {
      color: #ffffff;
      font-weight: 500;
      line-height: 1.5;
      text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
    }
    .headline {
      color: #ffffff;
      text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
    }
    background: #0d3d2e;
    background: linear-gradient(
      0deg,
      #0d3d2e 0%,
      #1a7055 100%
    );
  }
  tr:hover {
    background: #f7f7f7;
    box-shadow: 1px 1px rgba(0, 0, 0, 0.1);
  }
  td {
    height: 37px;
  }
  .faq_section {
    background-color: #f7f7f7;
    margin: 0;
  }
  h3 {
    text-align: center;
  }
  .td-custom {
    text-align: center;
  }
  .btn_custom {
    background-color: #1a7055 !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
    border: 2px solid transparent;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(26, 112, 85, 0.22);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  }
  .btn_custom:hover,
  .btn_custom:focus {
    background-color: #0d3d2e !important;
    color: #fff !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(13, 61, 46, 0.28);
  }
  .btn_custom:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
    /* Pair amber with dark halo so focus is visible on dark green button fill. */
    box-shadow:
      0 0 0 2px #0d3d2e,
      0 0 0 7px rgba(13, 61, 46, 0.55),
      0 8px 18px rgba(13, 61, 46, 0.28);
  }
  .table_heading {
    color: #fff;
    background-color: #1a7055;
    th, td {
      border: 3px #fff solid;
      height: 70px;
      font-weight: 600;
      line-height: 70px !important;
      font-size: 26px;
      color: #fff;
      text-align: center;
    }
    th.pl-3 { text-align: left; }
  }
  .true {
    color: #1a7055;
  }
  .false {
    color: #b71c1c;
  }
  .table_heading:hover {
    background-color: #1a7055;
  }
  /* improve focus on Vuetify v-carousel default controls */
  .v-carousel .v-btn:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
  }
  .testimonials {
    min-height: 60vh;
    p {
      padding: 20px;
      font-size: 18px;
      font-weight: 400;
      // text-align: center;
    }
    .testimonials_card {
      min-height: 300px;
      padding: 8px;
    }
    h4,
    .testimonial-name {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      margin-top: 8px;
    }
    .carousel {
      box-shadow: none;
      .jumbotron {
        background-color: #fff;
      }
      .carousel__left {
        button:hover {
          background-color: #fff;
        }
      }
    }
    /* strip Vuetify carousel/window default shadows so only the v-card shadow remains */
    .v-carousel,
    .v-window,
    .v-window__container,
    .v-carousel__item {
      box-shadow: none !important;
    }
    .v-card.elevation-2 {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
    }
  }
  .testimonial_img {
    position: relative;
    left: 47%;
    width: 80px;
    height: 80px;
  }
  @media screen and (max-width: 1024px) {
    .landing_color_bg {
      h1 {
        font-size: 42px;
        font-weight: 800;
        color: #fff;
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
      }
      .headline {
        font-size: 20px !important;
        font-weight: 400;
        line-height: 32px !important;
        letter-spacing: normal !important;
      }
    }
    #landing_graph_section .stock_card p {
      text-align: left;
      font-weight: 800;
      font-size: 11px;
      padding-left: 8px;
      padding-right: 3px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .table_heading {
      td {
        border: 3px #fff solid;
        height: 70px;
        font-weight: 400;
        line-height: 50px !important;
        font-size: 16px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .landing_color_bg h1 {
      font-size: 34px;
      font-weight: 800;
      color: #fff;
      text-shadow: 2px 2px 1px #31cc9a;
    }
    .headline {
      font-size: 16px !important;
      font-weight: 400;
      line-height: 22px !important;
      letter-spacing: normal !important;
    }
    #landing_graph_section h4 {
      font-size: 26px;
      font-weight: 600;
      line-height: 36px;
      text-align: center;
      margin: 30px 0;
    }
    #landing_graph_section p {
      text-align: center;
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 32px;
    }
    .table_heading td {
      border: 3px #fff solid;
      height: 70px;
      font-weight: 400;
      line-height: 40px !important;
      font-size: 20px;
    }
    .subheading {
      font-size: 14px !important;
    }
    .carousel {
      height: 550px;
    }
  }
  @media only screen and (max-width: 599px) {
    .custom_container {
      padding: 12px;
    }
    .pricing_tab{
      font-size: 12px;
    }
  }
  @media screen and (max-width: 480px) {
    #landing_graph_section .stock_card p {
      text-align: left;
      font-weight: 800;
      font-size: 11px;
      padding-left: 16px;
      padding-right: 20px;
      padding-top: 10px;
    }
    #landing_graph_section p {
      margin-bottom: 12px;
    }
    
    .table_heading td {
      border: 3px #fff solid;
      height: 70px;
      font-weight: 400;
      line-height: 20px !important;
    }
    .subheading {
      font-size: 14px !important;
    }
    .pricing_tab{
      font-size: 12px;
    }
    td {
      height: 50px;
    }
    table.table thead td:not(:first-child),
    table.table thead th:first-child,
    table.table thead th:not(:first-child) {
      padding: 15px 10px;
    }
    table.table thead td:first-child,
    table.table thead td:not(:first-child),
    table.table thead th:first-child,
    table.table thead th:not(:first-child) {
      padding: 15px 10px;
    }
    tr {
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    }
    .last_tr {
      height: 10vh;
      border-bottom: none;
    }
    .stock_card .download_report {
      position: absolute;
      bottom: 20px;
    }
    .pricing_tab {
      text-align: center;
      font-size: 12px;
      background: #f1f1f1;
      line-height: 24px;
      padding-top: 14px;
      padding-bottom: 14px;
      color: #2d2d2d;
      border: 2px solid #d4d4d4;
      font-weight: 600;
      min-height: 48px;
    }
    .pricing_tab[aria-selected="true"] {
      background: #1a7055;
      color: #fff;
      border-color: #0d3d2e;
    }
    .mobile_table_heading td {
      font-size: 30px;
    }

    .table.table tbody td:first-child,
    table.table tbody td:not(:first-child),
    table.table tbody th:first-child,
    table.table tbody th:not(:first-child),
    table.table thead td:first-child,
    table.table thead td:not(:first-child),
    table.table thead th:first-child,
    table.table thead th:not(:first-child) {
      padding: 10px 4px;
    }
    .active_pricing_tab {
      color: #fff;
      // background-color: #31cc9a;
      background-color: #000;
      font-weight: 800;;
    }
    .testimonials_card {
      min-height: 400px;
      p {
        text-align: center;
        font-size: 13px;
        font-weight: 500;
      }
    }
    .testimonial_img {
      position: relative;
      left: 39%;
      width: 70px;
      height: 70px;
    }
    .carousel {
      height: 550px;
    }
  }
  @media screen and (max-width: 375px) {
    .fullpage {
      padding-top: 0vh;
      min-height: 80vh;
    }

    .pricing_tab{
      font-size: 12px;
    }

    .testimonials_card {
      p {
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
      }
    }
  }

  .strike-through{
    text-decoration: line-through;
  }
  .limited_time{
    margin-bottom: 10px;
    // border:#096649 1px solid;
    border-radius: 20px;
    padding: 5px 10px;
    font-size: 10px;
    color: #000;
    background: #ffff;
  }
  .limited_time_green{
    margin-bottom: 10px;
    // border:#096649 1px solid;
    border-radius: 20px;
    padding: 5px 10px;
    font-size: 12px;
    color: #fff;
    background: #0d3d2e;
  }

  .btn--full{
    width: 100%;
  }
</style>

<!-- Non-scoped block: Vue 2.5 + vue-loader 13 + SCSS drops ::v-deep rules
     because SCSS treats ::v-deep as an unknown pseudo-element. These
     carousel overrides must reach v-carousel's child DOM, so they live here. -->
<style lang="scss">
  .carousel-nav-btn.v-btn {
    background-color: #1a7055 !important;
    color: #fff !important;
    margin: 0 6px;
    min-width: 44px !important;
    min-height: 44px !important;
    width: 44px !important;
    height: 44px !important;
    opacity: 1 !important;
    border-radius: 50% !important;
  }
  .carousel-nav-btn.v-btn:hover,
  .carousel-nav-btn.v-btn:focus {
    background-color: #0d3d2e !important;
    color: #fff !important;
  }
  .carousel-nav-btn.v-btn:focus,
  .carousel-nav-btn.v-btn:focus-visible {
    outline: 3px solid #0d3d2e !important;
    outline-offset: 3px !important;
    box-shadow: 0 0 0 6px #fff, 0 0 0 9px #0d3d2e !important;
  }
  /* Vuetify paints a currentColor overlay via .v-btn:before — neutralize it */
  .carousel-nav-btn.v-btn:before,
  .carousel-nav-btn.v-btn:hover:before,
  .carousel-nav-btn.v-btn:focus:before,
  .carousel-nav-btn.v-btn--active:before {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  .carousel-nav-btn .v-icon,
  .carousel-nav-btn i {
    color: #fff !important;
    font-size: 24px !important;
  }

  /* Direct Vuetify selectors — applies even if the JS relabel/classlist hook
     hasn't tagged the buttons with .carousel-nav-btn yet */
  .v-carousel .v-carousel__controls,
  .v-carousel__prev,
  .v-carousel__next {
    z-index: 2;
  }
  .v-carousel__prev .v-btn,
  .v-carousel__next .v-btn {
    background-color: #1a7055 !important;
    color: #fff !important;
    min-width: 44px !important;
    min-height: 44px !important;
    width: 44px !important;
    height: 44px !important;
    opacity: 1 !important;
    border-radius: 50% !important;
  }
  .v-carousel__prev .v-btn:before,
  .v-carousel__next .v-btn:before,
  .v-carousel__prev .v-btn:hover:before,
  .v-carousel__next .v-btn:hover:before,
  .v-carousel__prev .v-btn:focus:before,
  .v-carousel__next .v-btn:focus:before,
  .v-carousel__prev .v-btn--active:before,
  .v-carousel__next .v-btn--active:before {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  .v-carousel__prev .v-btn:hover,
  .v-carousel__next .v-btn:hover {
    background-color: #0d3d2e !important;
    color: #fff !important;
  }
  .v-carousel__prev .v-btn:focus,
  .v-carousel__next .v-btn:focus,
  .v-carousel__prev .v-btn:focus-visible,
  .v-carousel__next .v-btn:focus-visible {
    background-color: #0d3d2e !important;
    color: #fff !important;
    outline: 3px solid #0d3d2e !important;
    outline-offset: 3px !important;
    box-shadow: 0 0 0 6px #fff, 0 0 0 9px #0d3d2e !important;
  }
  .v-carousel__prev .v-icon,
  .v-carousel__next .v-icon,
  .v-carousel__prev i,
  .v-carousel__next i {
    color: #fff !important;
    font-size: 24px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Pricing.vue